import Vue from 'vue';
import * as utils from '../components/actModules/src/utils';
import * as shareUtils from './share';

[shareUtils, utils].map(util => Object.keys(util).forEach(key => {
	Vue.prototype[`$${key}`] = util[key];
}))

const context = require.context('../components/actModules/', true, /\.vue$/);
context.keys().forEach(key => {
	const comp = context(key).default;
	Vue.component(comp.name, comp);
	Vue.prototype.$componentConfig = Vue.prototype.$componentConfig || {}
	Vue.prototype.$componentConfig[comp.name] = comp.actConfig
});



// WEBPACK FOOTER //
// ./src/utils/initComponent.js